import defaultComponents from 'gatsby-theme-carbon/src/components/MDXProvider/defaultComponents';

import ComponentDocs from '../../../components/ComponentDocs';
import ComponentCode from '../../../components/ComponentCode';
import ComponentReact from '../../../components/ComponentReact';
import MdxIcon from '../../../components/MdxIcon';

export default {
  ...defaultComponents,
  ComponentDocs,
  ComponentCode,
  ComponentReact,
  MdxIcon,
};
